module.exports = __webpack_public_path__ + "static/media/side-bar-dashboard-icon-non-active.167cdef6.svg";